'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = responsiveStyleModifierPropTypes;

var _lodash = require('lodash.difference');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.flatten');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.forin');

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = require('lodash.iserror');

var _lodash8 = _interopRequireDefault(_lodash7);

var _lodash9 = require('lodash.keys');

var _lodash10 = _interopRequireDefault(_lodash9);

var _lodash11 = require('lodash.uniq');

var _lodash12 = _interopRequireDefault(_lodash11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateModifiers(propName, componentName, responsiveModifiers, modifierConfig) {
  var rawMissingModifiers = [];
  var rawSizesWithErrors = [];

  var modifierNames = (0, _lodash10.default)(modifierConfig);
  (0, _lodash6.default)(responsiveModifiers, function (v, k) {
    var noMatches = (0, _lodash2.default)(v, modifierNames);
    if (noMatches.length > 0) {
      rawMissingModifiers.push(noMatches);
      rawSizesWithErrors.push(k);
    }
  });

  var missingModifiers = (0, _lodash12.default)((0, _lodash4.default)(rawMissingModifiers));
  var sizesWithErrors = (0, _lodash12.default)(rawSizesWithErrors);

  if (missingModifiers.length > 0) {
    var m = missingModifiers.length > 1 ? 'modifiers' : 'modifier';
    var modifierList = missingModifiers.join(', ');
    var k = sizesWithErrors.length > 1 ? 'keys' : 'key';
    var sizes = sizesWithErrors.join(', ');
    return new Error('Invalid ' + m + ' ' + modifierList + ' used in prop \'' + propName + '\' (size ' + k + ' ' + sizes + ') and supplied to ' + componentName + '. Validation failed.');
  }

  return null;
}

/**
 * Evaluates the responsive modifiers prop against the size keys found in the reactive-container
 * package and the modifier config. Throws invalid proptype error if an incorrect size key is used
 * or a modifier is supplied in prop and not found in modifier config object.
 * @param  {Object} modifierConfig a modifier config object
 * @return {null:Error}           Returns null or an error
 */
function responsiveStyleModifierPropTypes(modifierConfig) {
  return function (props, propName, componentName) {
    var responsiveModifiers = props[propName];

    var validModifiers = validateModifiers(propName, componentName, responsiveModifiers, modifierConfig);

    if ((0, _lodash8.default)(validModifiers)) {
      return validModifiers;
    }

    return null;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-modifiers/dist/responsiveStyleModifierPropTypes.js
// module id = 1469
// module chunks = 2